function init() {
    if (window.fos === undefined) {
        window.Routing = window.Routing || {};
        var localhost = 'http://localhost:3005/';

        window.Routing = {
            generate: function(path, params) {
                switch (path) {
                    case 'app_inquiry.post':
                        return localhost + 'quick-response/save';
                    break;
                    case 'app_inquiry.patch_data':
                          return localhost + 'quick-response/save';
                    break;
                    case 'app_inquiry.add_response':
                          return localhost + 'quick-response/save';
                    break;
                    case 'app_inquiry.get':
                          return localhost + 'quick_response_edit.html';
                    break;
                    case 'app_estimation.get_all':
                          return localhost + 'estimations/list';
                    break;
                    case 'app_estimation_draft_category.add_draft':
                          return localhost + 'estimations/draft/add';
                    break;
                    case 'app_activity.get':
                          return localhost + 'activity-feed-search?' + params.params;
                    break;
                    default:
                        return '#';
                }
            }
        }
    }
}

export { init };



// WEBPACK FOOTER //
// ./src/_app/layout/routing.js